import {mapActions, mapMutations, mapGetters} from 'vuex';

import {required, alpha, maxLength, minLength} from "vuelidate/lib/validators";
import {validationMixin} from "vuelidate";

export default {
  name: 'countryGroups.edit',
  mixins: [validationMixin],
  data() {
    return {
      payload: {
        prefix: null,
        translations: [],
      },
      currentTranslations: 0,
      validationErrors: {},
    }
  },
  components: {},
  validations: {
    payload: {
      prefix: {
        required,
        alpha,
        minLength: minLength(1)
      },
      translations: {
        $each: {
          title: {
            required,
            minLength: minLength(1),
            maxLength: maxLength(20)
          }
        }
      }
    }
  },
  created() {

    let countryGroupId = parseInt(this.$route.params.countryGroupId);
    if (!this.countryGroup || this.countryGroup.id !== countryGroupId) {
      this.fetchCountryGroup(countryGroupId).then(()=>{
        this._applyData();
      })
    } else {
      this._applyData();
    }
  },
  mounted() {},
  computed: {
    ...mapGetters({
      countryGroup: 'countryGroups/countryGroup',
      isCountryGroupLoading: 'countryGroups/isCountryGroupLoading',
      isCountryGroupUpdating: 'countryGroups/isCountryGroupUpdating',
    }),
    ...mapGetters([
      'languages',
    ]),
    prefixErrors() {
      let error = [];
      if (!this.$v.payload.prefix.$dirty) {
        return error;
      }
      if (!this.$v.payload.prefix.required) {
        error.push(this.$t('validationRequired'));
      }
      if (!this.$v.payload.prefix.minLength) {
        error.push(this.$t('validationMin',{count: 1}));
      }
      if (!this.$v.payload.prefix.alpha) {
        error.push(this.$t('validationAlpha'));
      }
      if (this.validationErrors.prefix) {
        this.validationErrors.prefix.forEach((row) => {
          error.push(row);
        })
      }
      return error;
    },
  },
  methods: {
    ...mapActions({
      fetchCountryGroup: 'countryGroups/COUNTRY_GROUP_REQUEST_DATA_GET',
      editCountryGroups: 'countryGroups/COUNTRY_GROUP_REQUEST_UPDATE',
    }),
    ...mapMutations({}),
    _applyData() {
      this.payload.prefix = this.countryGroup.prefix;
      this.payload.translations = this.languages.map(langItem => {
        let lang = this.countryGroup.translations.data.filter(translationItem => {
          return translationItem.locale === langItem.translationKey;
        })[0];

        let translationItem = {
          locale: langItem.translationKey,
          title: ''
        }

        if (lang) {
          translationItem = Object.assign(translationItem, {
            title: lang.title,
            description: lang.description,
          })
        }

        return translationItem
      });
    },
    translationsTitleErrors(index) {
      let error = [];
      if (!this.$v.payload.translations.$each[index].title.$dirty) {
        return error;
      }
      if (!this.$v.payload.translations.$each[index].title.required) {
        error.push(this.$t('validationRequired'));
      }
      if (!this.$v.payload.translations.$each[index].title.minLength) {
        error.push(this.$t('validationMin',{count: 1}));
      }
      if (!this.$v.payload.translations.$each[index].title.maxLength) {
        error.push(this.$t('validationMax',{count: 20}));
      }
      return error;
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {

        let payload = {
          prefix: this.payload.prefix,
        }
        this.payload.translations.forEach(item => {
          payload[item.locale] = {
            title: item.title,
          }
        });
        this.editCountryGroups({
          countryGroupId: this.countryGroup.id,
          payload: payload
        }).then(() => {
          this.$toasted.success(this.$t('dataUpdated'));
          this.$router.push({name: 'countryGroups.list'}).catch(() => {console.log();});
        }).catch(error => {
          if (error.response.status === 422) {
            this.$toasted.error(error.response.data.message);
            this.validationErrors = error.response.data.errors
          }
        });
      }
    }
  }
}
